// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b3cc00dc","239":"522c43d0","455":"636c068c"}[chunkId] + ".chunk.js";
};